
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/item",
      function () {
        return require("private-next-pages/docs/errors/item.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/item"])
      });
    }
  